import { Handle, Position, type NodeProps } from "@xyflow/react";
import { Box, Chip, Typography } from "@mui/material";
import ApiOutlinedIcon from "@mui/icons-material/ApiOutlined";
import type { PrepFlowNodeData } from "../../utils/graphAdapter";
import { useAppCustomStyles } from "../../../../assets/theme/custom/hooks";

export default function PrepOpenApiQueryNode({ data }: NodeProps) {
  const flowData = data as PrepFlowNodeData;
  const custom = useAppCustomStyles();
  const node = flowData.graphNode;
  const caption = node.openApiToolName
    ? `${node.openApiTag || "—"} / ${node.openApiToolName}`
    : node.openApiCatalogId
      ? "catalog selected"
      : "— OpenAPI —";
  return (
    <Box
      sx={custom.components.dataPrep.dslQueryNode({
        stale: flowData.stale,
        error: flowData.error,
        tested: flowData.tested,
      })}
    >
      <Handle type="target" position={Position.Left} />
      <Box sx={custom.components.dataPrep.flowNodeTitleRow}>
        <ApiOutlinedIcon fontSize="small" color="primary" />
        <Typography variant="subtitle2" fontWeight={600}>
          {node.label || "OpenAPI"}
        </Typography>
      </Box>
      <Typography variant="caption" color="text.secondary" sx={custom.components.dataPrep.flowNodeCaption}>
        {caption}
      </Typography>
      {flowData.stale && (
        <Chip size="small" label="Stale" color="warning" sx={custom.components.dataPrep.dslQueryNodeChipWithMargin} />
      )}
      {flowData.tested && !flowData.stale && (
        <Chip size="small" label="Tested" color="success" sx={custom.components.dataPrep.dslQueryNodeChip} />
      )}
      {flowData.error && (
        <Chip size="small" label="Error" color="error" sx={custom.components.dataPrep.dslQueryNodeChip} />
      )}
      <Handle type="source" position={Position.Right} />
    </Box>
  );
}
